import { useState } from "react";
import { styled } from "styled-components";
import { lang } from "../assets/languages/en.language";
import { theme } from "../configs/theme";
import api from "../services/api";
import { QuestionContainer } from "../styles/Container.style";
import { Title } from "../styles/Text";
import Popup from "./Popup.component";
import { MegaphoneIcon } from "./svgs/icons/Megaphone.icon";
import { ThreeDots } from "./svgs/icons/Three-dots.icon";
import { WarningIcon } from "./svgs/icons/Warnings.icon";

interface MoreButtonProps {
  profileId: string;
}

export const MoreButton = ({ profileId }: MoreButtonProps) => {
  const [showMorePopup, setShowMorePopup] = useState<boolean>(false);
  const [showBlockPopup, setShowBlockPopup] = useState<boolean>(false);
  const [showReportPopup, setShowReportPopup] = useState<boolean>(false);

  const reportProfile = async () => {
    try {
      await api.reportProfile(profileId);
      window.location.reload();
    } catch (err) {
      console.log("Error reporting specific profile", err);
      alert("Error reporting specific profile");
    }
  };

  const blockProfile = async () => {
    try {
      await api.blockProfile(profileId);
      window.location.reload();
    } catch (err) {
      console.log("Error blocking specific profile", err);
      alert("Error blocking specific profile");
    }
  };

  return (
    <>
      <RootContainer onClick={() => setShowMorePopup(true)}>
        <Title $color={theme.color.primaryDark}>More...</Title>
      </RootContainer>
      {showMorePopup && (
        <Popup
          type="info"
          title={lang.swiperPage.morePopup.title}
          buttonText={lang.swiperPage.morePopup.buttonText}
          buttonText2={lang.swiperPage.morePopup.buttonText2}
          Icon={ThreeDots}
          onClose={() => setShowMorePopup(false)}
          action={() => {
            setShowMorePopup(false);
            setShowReportPopup(true);
          }}
          action2={() => {
            setShowMorePopup(false);
            setShowBlockPopup(true);
          }}
        />
      )}
      {showBlockPopup && (
        <Popup
          type="info"
          title={lang.swiperPage.blockPopup.title}
          message={lang.swiperPage.blockPopup.message}
          buttonText={lang.swiperPage.blockPopup.buttonText}
          Icon={MegaphoneIcon}
          onClose={() => {
            setShowBlockPopup(false);
            setShowMorePopup(true);
          }}
          action={() => {
            blockProfile();
            setShowBlockPopup(false);
          }}
        />
      )}
      {showReportPopup && (
        <Popup
          type="info"
          title={lang.swiperPage.reportPopup.title}
          message={lang.swiperPage.reportPopup.message}
          buttonText={lang.swiperPage.reportPopup.buttonText}
          Icon={WarningIcon}
          onClose={() => {
            setShowReportPopup(false);
            setShowMorePopup(true);
          }}
          action={() => {
            reportProfile();
            setShowReportPopup(false);
          }}
        />
      )}
    </>
  );
};

const RootContainer = styled(QuestionContainer)`
  align-items: center;
`;
